// @mui
import { Box, Typography, Stack } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';

// ----------------------------------------------------------------------

export default function BlockContent() {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      direction={"column"}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' } }}
    >
      <UploadIllustration sx={{ maxWidth: 100 }} />

      <Box sx={{ p: { xs: 1, sm: 2 } }}>
        <Typography gutterBottom variant="h5" textAlign="center">
          Drop or Select file
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Drop files here or click&nbsp;
          <Typography
            variant="body2"
            component="span"
            sx={{ color: 'primary.main', textDecoration: 'underline' }}
          >
            browse
          </Typography>
          &nbsp;through your machine
        </Typography>
      </Box>
    </Stack>
  );
}
